export default "__VITE_ASSET__8b6c59d8__"